// import { Backdrop, CircularProgress } from '@material-ui/core';
// import { makeStyles } from '@material-ui/core/styles';
import React, { createContext, useReducer } from 'react';

const SET_LINKS = 'SET_LINKS';

export const BreadCrumbContext = createContext(null);

const initialState = {
  links: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LINKS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

const setBreadCrumbsAction = (links) => ({
  type: SET_LINKS,
  payload: { links },
});
const resetBreadCrumbsAction = () => ({
  type: SET_LINKS,
  payload: { links: [] },
});

const BreadCrumbContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const setBreadCrumbs = (links) => dispatch(setBreadCrumbsAction(links));
  const resetBreadCrumbs = () => dispatch(resetBreadCrumbsAction());

  return (
    <BreadCrumbContext.Provider
      value={{
        setBreadCrumbs,
        resetBreadCrumbs,
        ...state,
      }}>
      {children}
    </BreadCrumbContext.Provider>
  );
};

export default BreadCrumbContextProvider;
